import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";

interface AvatarMenuItem {
  text: string;
  action: string;
  icon: React.ReactNode;
}

interface AvatarMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onItemClick: (action: string) => void;
  items: AvatarMenuItem[];
  isRtl: boolean;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onItemClick,
  items,
  isRtl,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: isRtl ? "right" : "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: isRtl ? "right" : "left",
      }}
      slotProps={{
        paper: {
          elevation: 8,
          sx: {
            width: 200,
            borderRadius: 2,
            backgroundColor: "white",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            "& .MuiMenuItem-root": {
              py: 1.5,
              px: 2,
              "&:hover": {
                backgroundColor: "rgba(88, 152, 255, 0.1)",
              },
            },
            "& .MuiDivider-root": {
              my: 0.5,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              bottom: 20,
              insetInlineEnd: "-8px",
              width: 0,
              height: 0,
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderInlineEnd: "8px solid white",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
              zIndex: 1,
            },
          },
        },
      }}
    >
      {items
        .map((item, index, array) => [
          <MenuItem key={item.action} onClick={() => onItemClick(item.action)}>
            <ListItemIcon sx={{ minWidth: 36, color: "#5898ff" }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "text.primary",
              }}
            />
          </MenuItem>,
          index < array.length - 1 && (
            <Divider key={`divider-${item.action}`} />
          ),
        ])
        .flat()
        .filter(Boolean)}
    </Menu>
  );
};

export default AvatarMenu;